/** Must be in sync with fleet backend equivalent enum  */
export enum ERoutes {
	search = '/search',
	home = '/',
	trips = '/trips',
	tripInfo = '/trip-info',
	rateTrip = '/feedback',
	thankYou = '/thank-you',
	any = '*',
	tel = 'tel:',
	blank = '_blank',
	noopener = 'noopener,noreferrer',
	id = '/:id',
}

export enum ERefreshRates {
	navigation = 'navigation',
	reload = 'reload',
}
